import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { marketShareB2bConfig } from "@/lib/datasetRegistry"

// Thin config module — driven by `marketShareB2bConfig` (SL shape + period-range
// preview labels, "Mendeteksi template…" copy, preview hidden while the upload
// POST is in flight). Page-specific JSX is the breadcrumb and the
// supported-templates dropzone line. Controller renders
// "admin/market_share_b2b/Uploads".
export default function AdminMarketShareB2bUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return (
    <DatasetUploadsPage
      config={marketShareB2bConfig}
      headerBanner={
        <div className="mb-2 flex items-center gap-1.5 text-xs text-ink-muted">
          <span>Data</span>
          <span>/</span>
          <span>B2B Data</span>
          <span>/</span>
          <span className="text-ink-body font-medium">B2B - Market Share</span>
        </div>
      }
      dropzoneDetail={
        <p className="mt-1 text-xs text-ink-muted">
          Template yang didukung: IDG (MarketShareMOCY), IDM (Reguler / Skincare), MIDI, SAT
        </p>
      }
      {...props}
    />
  )
}
